import * as yup from 'yup';

import { endpoint, EndpointError } from 'endpoints/endpoint';

import { ERROR as VALIDATION_ERROR } from '../validation';

export type CreateRoomParams = { roomId: string; withRecording: boolean };
export type CreateRoomResult = { data: 'OK' };
export type CreateRoomError = EndpointError;

export const createRoom = endpoint<CreateRoomParams, CreateRoomResult, CreateRoomError>({
  method: 'POST',
  url: () => '/live-kit/create-room',
});

export const createRoomParamsSchema: yup.SchemaOf<CreateRoomParams> = yup.object().shape({
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
  withRecording: yup.boolean().required(VALIDATION_ERROR.REQUIRED),
});
